import { RouteMatches } from './routes.helpers';

export type AppLayoutContext = {
  matches: RouteMatches;
  isMobile: boolean;
};

const isFullScreenEverywhere = (routes: RouteMatches): boolean => routes.isAuthPath
  || routes.isPayoutsPath
  || routes.isProductsPath
  || routes.isTradingViewPath
  || routes.isErrorPath
  || routes.isPaymentPlanErrorPath
  || routes.isPaymentSuccessPath
  || routes.isPaymentMethodSelectionPath
  || routes.isDemoPlanActivationErrorPath
  || routes.isEnrollPhoneVerification
  || routes.isEnrollPhoneVerificationOtp
  || routes.isEnrollPhoneVerified;

const isFullScreenOnMobile = (routes: RouteMatches): boolean => routes.isBuyOrSellPath
  || routes.isModifyPath
  || routes.isPayoutHistoryPath
  || routes.isTradeHistoryPath
  || routes.isSearchSymbolMobPath;

const isFullScreenOnDesktop = (routes: RouteMatches): boolean => routes.isCryptoPaymentPath
  || routes.isPaymentCancelPath;

export const isFullScreenRoute = ({ matches, isMobile }: AppLayoutContext): boolean => {
  if (isFullScreenEverywhere(matches)) {
    return true;
  }

  return isMobile ? isFullScreenOnMobile(matches) : isFullScreenOnDesktop(matches);
};
